"use strict";
/**
 * The start fields a row hands an automation for its choice cells: each
 * option as `{ id, label }`, the label read from the column's options. The
 * platform's input processor and the standalone StreamKit read them alike.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.automationSelectInput = automationSelectInput;
exports.automationMultiSelectInput = automationMultiSelectInput;
/** A choice the column no longer lists keeps its id as label. */
function automationSelectInput(value, labels) {
    if (value === null || value === undefined)
        return null;
    const id = String(value);
    return { id, label: labels?.get(id) ?? id };
}
function automationMultiSelectInput(value, labels) {
    if (!Array.isArray(value))
        return [];
    return value.map(id => {
        const idStr = String(id);
        return { id: idStr, label: labels?.get(idStr) ?? idStr };
    });
}
